import { Icon } from '@acast/decibel';
import { SortDownSolidGlyph, SortSolidGlyph, SortUpSolidGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import { showPropType } from '../../../../customPropTypes';
import navigateTo from '../../../../shared/helpers/navigate-to';
import OverviewShowsListItem from '../overview-shows-list-item';

function renderListItem(show) {
  const showId = show.id;
  return (
    <OverviewShowsListItem
      key={showId}
      show={show}
      onClick={() => navigateTo(`/shows/${showId}`)}
    />
  );
}

function renderNoShowMessage() {
  return (
    <tr className="overview-shows-list-view-no-shows">
      <td colSpan="5">No shows.</td>
    </tr>
  );
}

function getSortGlyph(isActive, direction) {
  if (isActive && direction === 'ascending') {
    return SortUpSolidGlyph;
  }
  if (isActive && direction === 'descending') {
    return SortDownSolidGlyph;
  }
  return SortSolidGlyph;
}

function OverviewShowsListView({ shows, sortOnKeyAscending, sortKey, sortAscending }) {
  const isSortingOn = key => key === sortKey;

  const sortOrder = sortAscending ? 'ascending' : 'descending';
  const createTableHeading = (label, headingSortKey) => {
    const isActive = isSortingOn(headingSortKey);
    return (
      <th
        className={isActive ? `is-sorting ${sortOrder}` : ''}
        onClick={() => sortOnKeyAscending(headingSortKey)}
        data-test-id="OverviewShowsListView__header"
      >
        {label}
        <Icon glyph={getSortGlyph(isActive, sortOrder)} size="1em" />
      </th>
    );
  };

  return (
    <div className="overview-shows-list-view">
      <table className="overview-shows-list">
        <thead>
          <tr>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th />
            {createTableHeading('Name', 'show.name')}
          </tr>
        </thead>
        <tbody>
          {shows.length > 0 ? shows.map(show => renderListItem(show)) : renderNoShowMessage()}
        </tbody>
      </table>
    </div>
  );
}

OverviewShowsListView.propTypes = {
  shows: T.arrayOf(showPropType).isRequired,
  sortOnKeyAscending: T.func.isRequired,
  sortKey: T.string,
  sortAscending: T.bool,
};

export default OverviewShowsListView;
